import { Flex, Switch, Text } from '@chakra-ui/react';
import { useId, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ShareWithTeamInviteModal } from './ShareWithTeamInviteModal';

type ShareWithTeamProps = {
  disabled?: boolean;
  enableTeamShare?: boolean;
  mode?: 'team' | 'education';
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onCopyLink?: (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
  onNotify?: (message: string) => void;
  onClose?: () => void;
};

export const ShareWithTeam = ({
  disabled = false,
  mode = 'team',
  enableTeamShare = false,
  onChange = () => {},
  onCopyLink = () => {},
  onNotify = () => {},
}: ShareWithTeamProps) => {
  const { t } = useTranslation('common_navbar');
  const [showTeamInviteModal, setShowTeamInviteModal] = useState(false);
  const shareId = useId();
  const title =
    mode === 'education'
      ? t('modals.share-panel.share-with-team.title-edu')
      : t('modals.share-panel.share-with-team.title');

  const handleInviteModalClose = () => {
    setShowTeamInviteModal(false);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // Show an additional modal for notify to team when teamshare is enabled.
    if (mode === 'team' && event.target.checked) {
      // only for the team type
      setShowTeamInviteModal(true);
    }

    onChange(event);
  };

  const handleNotify = (message: string) => {
    onNotify(message);
  };

  const shareWithTeamTestId = 'share-with-team';

  return (
    <>
      <Flex flexDir='column' data-testid={shareWithTeamTestId}>
        <Flex flexDir='column' gap='2'>
          <Flex flexDir='row' justifyContent='space-between' alignItems='center'>
            <Text
              fontWeight={'semibold'}
              fontSize='sm'
              lineHeight='1.25'
              color={'font.500'}
              htmlFor={shareId}
              as={'label'}
            >
              {title}
            </Text>
            <Switch
              id={shareId}
              disabled={disabled}
              isChecked={enableTeamShare}
              onChange={handleChange}
              colorScheme='blue'
            />
          </Flex>
          <Flex flexDir='row' justifyContent='space-between' alignItems='center'>
            <Flex direction={'column'} color='font.300'>
              {mode === 'education' ? (
                <>
                  <Text fontSize='xs' lineHeight='1.43'>
                    {t('modals.share-panel.share-with-team.message-edu')}
                  </Text>
                </>
              ) : (
                <>
                  <Text fontSize='xs' lineHeight='1.43'>
                    {t('modals.share-panel.share-with-team.message1')}
                  </Text>
                  <Text fontSize='xs' lineHeight='1.43'>
                    {t('modals.share-panel.share-with-team.message2')}
                  </Text>
                </>
              )}
            </Flex>
          </Flex>
        </Flex>
      </Flex>

      <ShareWithTeamInviteModal
        isOpen={showTeamInviteModal}
        onNotify={handleNotify}
        onClose={handleInviteModalClose}
        onCopyLink={onCopyLink}
      />
    </>
  );
};
